
/* styles */
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-32b2b7e6&scoped=true!less-loader?sourceMap!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./TopBar.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./TopBar.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-32b2b7e6!../../node_modules/vue-loader/lib/selector?type=template&index=0!./TopBar.vue"),
  /* scopeId */
  "data-v-32b2b7e6",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/TopBar.vue
// module id = 948
// module chunks = 40